export enum Geschlecht {
    Maennlich = 'M',
    Weiblich = 'W',
    Divers = 'D',
    KeineAngaben = 'X',
}
